import {OptimizeStatus} from "./optimize-status";

export class OptimizeStatusMapper {
  public static map(data: any) {
    const optimizeStatus: OptimizeStatus = new OptimizeStatus();
    optimizeStatus.pageIsCached = !!data.page_is_cached;
    optimizeStatus.pageIsOptimized = !!data.page_is_optimized;
    optimizeStatus.cachingDate = parseInt(data.cache_clear_date, 10);
    return optimizeStatus;
  }
}
